import { TOAST_TYPES } from "@/shared/data/enums/toast";
import classNames from "classnames";
import { toast, ToastPosition } from "react-toastify";
import Alert from "./Alert";

type ToastAlertType = {
  toastType: TOAST_TYPES;
  message: string;
  position?: ToastPosition;
  customDefaultIcon?: string;
  lineBreak?: boolean;
  duration?: number;
};

const ToastAlert = ({
  toastType,
  message,
  position = "top-center",
  customDefaultIcon,
  lineBreak,
  duration,
}: ToastAlertType) => {
  const { SUCCESS, ERROR, DEFAULT } = TOAST_TYPES;
  const messageClassObj = {
    [SUCCESS]: { text: "text-successDark", bgColor: "bg-successLight" },
    [ERROR]: { text: "text-errorDark", bgColor: "bg-errorLight" },
    [DEFAULT]: { text: "text-warningDark", bgColor: "bg-warningLight" },
  };

  return toast(
    <Alert
      toastProps
      message={message}
      iconHeight="h-5"
      iconWidth="w-5"
      toastType={toastType}
      customDefaultIcon={customDefaultIcon}
      lineBreak={lineBreak}
    />,
    {
      position,
      autoClose: duration || 2000,
      className: classNames(
        messageClassObj[toastType].bgColor,
        `!w-max mx-auto !md:w-fit !px-5  !text-body !min-h-[54px]`
      ),
    }
  );
};

export default ToastAlert;
